import { PaletteResponse } from "pages/media/types";
import { Space, Switch } from "antd";
import { OpacitySlider } from "../../../controls/OpacitySlider";
import { useTemplatesStatusStore } from "../../../../store/useTemplatesStatusStore";
import { useTemplateEditorStore } from "../../../../store/useTemplateEditorStore";
import { PlaceholderColorPicker } from "../../../controls/PlaceholderColorPicker";
import {
  resolveColorToBrandKitPlaceholder,
  isGradient,
} from "../../../../helpers/itemsHelper";
import { DEFAULT_COLOR } from "../../../../constants";

export const AvatarShapeColorFeature = ({
  brandKitPalette,
}: {
  brandKitPalette: PaletteResponse;
}) => {
  const { presenter, setPresenter } = useTemplateEditorStore((store) => ({
    presenter: store.templateState.presenter,
    setPresenter: store.setPresenter,
  }));

  const addTemplateUpdate = useTemplatesStatusStore(
    (state) => state.addTemplateUpdate
  );

  const handleBackgroundToggle = (checked: boolean) => {
    const backgroundColor = checked
      ? resolveColorToBrandKitPlaceholder(
          brandKitPalette.primary_color,
          brandKitPalette
        )
      : undefined;

    setPresenter({
      background: backgroundColor,
      stroke: undefined,
    });
    addTemplateUpdate();
  };

  const isBackgroundEnabled = !!presenter.background;

  return (
    <>
      <Switch
        checked={isBackgroundEnabled}
        onChange={handleBackgroundToggle}
        style={{ position: "absolute", top: 10, right: 8 }}
        size="small"
      />
      {isBackgroundEnabled && (
        <Space>
          <PlaceholderColorPicker
            shape="square"
            showText={false}
            value={presenter.background}
            palette={brandKitPalette}
            mode={["single", "gradient"]}
            onClear={() => {
              setPresenter({
                background: undefined,
                stroke: undefined,
              });
              addTemplateUpdate();
            }}
            onChangeComplete={(resolvedColor) => {
              setPresenter({
                background: resolvedColor,
              });
              addTemplateUpdate();
            }}
            allowClear
            disabledAlpha
            triggerProps={{
              $backgroundColor: "transparent",
            }}
          />
          <OpacitySlider
            hexColor={
              isGradient(presenter.background)
                ? DEFAULT_COLOR
                : (presenter.background ?? DEFAULT_COLOR)
            }
            disabled={isGradient(presenter.background)}
            palette={brandKitPalette}
            onChange={(hexColorWithOpacity) => {
              setPresenter({
                background: hexColorWithOpacity,
              });
              addTemplateUpdate();
            }}
          />
        </Space>
      )}
    </>
  );
};
